<app-filters-slider>
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
    <li [ngbNavItem]="1" domId="filter-all-tab">
      <button ngbNavLink i18n="@@flightFiltersAll">All</button>
      <ng-template ngbNavContent>
        @if (ourFilters?.privateFares && (ourFilters.privateFares | keyvalue).length > 0) {
          <div class="privateFares filters-group">
            <fieldset>
              <legend>
                <h3>
                  <b i18n="@@negotiatedRates">Negotiated Rates</b>
                </h3>
              </legend>
              <app-select-filter
                [items]="ourFilters?.privateFares"
                [alphabetical]="true"
                (change)="applyFilter(ourFilters)"
              ></app-select-filter>
            </fieldset>
          </div>
        }
        @if (ourFilters?.vias && (ourFilters.vias | keyvalue).length > 0) {
          <div class="vias filters-group">
            <fieldset>
              <legend>
                <div class="flex-row-container">
                  <h3>
                    <b i18n="@@filterFlightsVia">Via</b>
                  </h3>
                  @if ((ourFilters?.vias | keyvalue).length > 5) {
                    <span
                      class="flight-filters-show-more"
                      (click)="viaShowmore = !viaShowmore"
                      (keydown.enter)="viaShowmore = !viaShowmore"
                      (keydown.space)="viaShowmore = !viaShowmore"
                      tabindex="0"
                      role="button"
                      id="toggle_amenities_button"
                      aria-labelledby="via_show_more_text"
                    >
                      <span id="via_show_more_text">
                        @if (!viaShowmore) {
                          <span i18n="@@filtersFlightsShowMore">Show more</span>
                        }
                        @if (viaShowmore) {
                          <span i18n="@@filtersFlightsShowLess">Show less</span>
                        }
                        <span class="visuallyhidden" i18n="@@filtersFlightsViaFilters"
                          >&nbsp;via filters</span
                        >
                      </span>
                      @if (!viaShowmore) {
                        <i class="ico-chevron-down" aria-hidden="true"></i>
                      }
                      @if (viaShowmore) {
                        <i class="ico-chevron-up" aria-hidden="true"></i>
                      }
                    </span>
                  }
                </div>
              </legend>
              <app-select-filter
                [items]="ourFilters?.vias"
                [alphabetical]="true"
                (change)="applyFilter(ourFilters)"
                [toggleable]="true"
                ariaLabelTitle="via"
                [showAll]="viaShowmore"
              ></app-select-filter>
            </fieldset>
          </div>
        }
        @if (!searchParams.bySchedule) {
          <div class="pricerange filters-group">
            <h3 id="price_range">
              <b i18n="@@filterFlightsPriceRange">Price Range</b>
            </h3>
            <div class="custom-slider">
              <ngx-slider
                aria-labelledby="price_range"
                id="flight-filter-price-range"
                [options]="priceOptions"
                (valueChange)="applyFilter(ourFilters)"
                (highValueChange)="applyFilter(ourFilters)"
                [(value)]="ourFilters.price.min"
                [(highValue)]="ourFilters.price.max"
              >
              </ngx-slider>
            </div>
          </div>
        }
        <div class="stops filters-group">
          <fieldset>
            <legend>
              <h3>
                <b i18n="@@filterFlightsStops">Stops</b>
              </h3>
            </legend>
            <app-select-filter
              [items]="ourFilters?.stops"
              (change)="applyFilter(ourFilters)"
            ></app-select-filter>
          </fieldset>
        </div>
        <div class="travelPolicy filters-group">
          <fieldset>
            <legend>
              <h3>
                <b i18n="@@travelPolicy">Travel Policy</b>
              </h3>
            </legend>
            <app-select-filter
              [items]="ourFilters?.travelPolicy"
              [alphabetical]="true"
              (change)="applyFilter(ourFilters)"
            ></app-select-filter>
          </fieldset>
        </div>
        @if (ourFilters?.ndcFares['NDC']) {
          <div class="ndcFares filters-group">
            <fieldset>
              <legend>
                <h3>
                  <b i18n="@@ndcFares">Fare Content</b>
                </h3>
              </legend>
              <app-select-filter
                [items]="ourFilters?.ndcFares"
                [alphabetical]="true"
                (change)="applyFilter(ourFilters)"
              ></app-select-filter>
            </fieldset>
          </div>
        }
        <div class="operators filters-group">
          <fieldset>
            <legend>
              <h3>
                <b i18n="@@filterFlightsAirlines">Airlines</b>
              </h3>
            </legend>
            <app-select-filter
              [items]="ourFilters?.airlines"
              [alphabetical]="true"
              (change)="applyFilter(ourFilters)"
            ></app-select-filter>
          </fieldset>
        </div>
        @if (
          searchParams.chosenSearchType === FlightSearchType.multiCity && !searchParams.bySchedule
        ) {
          <div class="operators filters-group">
            <h3>
              <b i18n="@@filterFlightsFlightNumber" id="outbound_flightnum_input_label"
                >Flight Number</b
              >
            </h3>
            <input
              appInput
              [border]="true"
              [noIcon]="true"
              [(ngModel)]="ourFilters.flightNumber"
              aria-labelledby="outbound_flightnum_input_label"
              id="flight-filters-input-flightnumber"
              i18n-placeholder
              placeholder="Enter flight number..."
              (ngModelChange)="applyFilter(ourFilters)"
              type="text"
            />
          </div>
          <div class="deprange filters-group">
            <h3 id="departure_time_range">
              <b i18n="@@filterFlightsDepartureTime">Departure Time</b>
            </h3>
            <div class="custom-slider">
              <ngx-slider
                aria-labelledby="departure_time_range"
                [options]="depTimeOptions"
                id="flight-filter-dep-time"
                (valueChange)="applyFilter(ourFilters)"
                (highValueChange)="applyFilter(ourFilters)"
                [(value)]="ourFilters.departureTime.min"
                [(highValue)]="ourFilters.departureTime.max"
              ></ngx-slider>
            </div>
          </div>
          <div class="arrrange filters-group">
            <h3 id="arrival_time_range">
              <b i18n="@@filterFlightsArrivalTime">Arrival Time</b>
            </h3>
            <div class="custom-slider">
              <ngx-slider
                aria-labelledby="arrival_time_range"
                [options]="arrTimeOptions"
                (valueChange)="applyFilter(ourFilters)"
                (highValueChange)="applyFilter(ourFilters)"
                id="flight-filter-arrival-time"
                [(value)]="ourFilters.arrivalTime.min"
                [(highValue)]="ourFilters.arrivalTime.max"
              ></ngx-slider>
            </div>
          </div>
        }
      </ng-template>
    </li>
    @if (searchParams.chosenSearchType !== FlightSearchType.multiCity || searchParams.bySchedule) {
      <li [ngbNavItem]="2" domId="filter-outbound-tab">
        <button ngbNavLink i18n="@@flightFiltersOutbound">Outbound</button>
        <ng-template ngbNavContent>
          <div class="operators filters-group">
            <h3>
              @if (
                searchParams.chosenSearchType === FlightSearchType.return &&
                !searchParams.bySchedule
              ) {
                <b i18n="@@filterFlightsOutboundFlightNumber" id="outbound_flightnum_input_label"
                  >Outbound Flight Number</b
                >
              }
              @if (
                searchParams.chosenSearchType !== FlightSearchType.return || searchParams.bySchedule
              ) {
                <b i18n="@@filterFlightsFlightNumber" id="outbound_flightnum_input_label"
                  >Flight Number</b
                >
              }
            </h3>
            <input
              appInput
              [border]="true"
              [noIcon]="true"
              [(ngModel)]="ourFilters.flightNumber"
              aria-labelledby="outbound_flightnum_input_label"
              id="flight-filters-input-flightnumber"
              i18n-placeholder
              placeholder="Enter flight number..."
              (ngModelChange)="applyFilter(ourFilters)"
              type="text"
            />
          </div>
          <div class="deprange filters-group">
            <h3 id="departure_time_range">
              <b i18n="@@filterFlightsDepartureTime">Departure Time</b>
            </h3>
            <div class="custom-slider">
              <ngx-slider
                aria-labelledby="departure_time_range"
                [options]="depTimeOptions"
                id="flight-filter-dep-time"
                (valueChange)="applyFilter(ourFilters)"
                (highValueChange)="applyFilter(ourFilters)"
                [(value)]="ourFilters.departureTime.min"
                [(highValue)]="ourFilters.departureTime.max"
              ></ngx-slider>
            </div>
          </div>
          <div class="arrrange filters-group">
            <h3 id="arrival_time_range">
              <b i18n="@@filterFlightsArrivalTime">Arrival Time</b>
            </h3>
            <div class="custom-slider">
              <ngx-slider
                aria-labelledby="arrival_time_range"
                [options]="arrTimeOptions"
                (valueChange)="applyFilter(ourFilters)"
                (highValueChange)="applyFilter(ourFilters)"
                id="flight-filter-arrival-time"
                [(value)]="ourFilters.arrivalTime.min"
                [(highValue)]="ourFilters.arrivalTime.max"
              ></ngx-slider>
            </div>
          </div>
          <div class="depPorts filters-group">
            <fieldset>
              <legend>
                <h3>
                  <b i18n="@@filterFlightsDepartFrom">Depart from</b>
                </h3>
              </legend>
              <app-select-filter
                [items]="ourFilters?.depatureAirport"
                (change)="applyFilter(ourFilters)"
              ></app-select-filter>
            </fieldset>
          </div>
          <div class="arrPorts filters-group">
            <fieldset>
              <legend>
                <h3>
                  <b i18n="@@filterFlightsArriveAt">Arrive at</b>
                </h3>
              </legend>
              <app-select-filter
                [items]="ourFilters?.arrivalAirport"
                (change)="applyFilter(ourFilters)"
              ></app-select-filter>
            </fieldset>
          </div>
        </ng-template>
      </li>
    }
    @if (searchParams.chosenSearchType === FlightSearchType.return && !searchParams.bySchedule) {
      <li [ngbNavItem]="3" domId="filter-inbound-tab">
        <button ngbNavLink i18n="@@flightFiltersInbound">Inbound</button>
        <ng-template ngbNavContent>
          @if (
            searchParams.chosenSearchType === FlightSearchType.return && !searchParams.bySchedule
          ) {
            <div class="operators filters-group">
              <h3>
                <b i18n="@@filterFlightsInboundFlightNumber" id="inbound_flightnum_input_label"
                  >Inbound Flight Number</b
                >
              </h3>
              <input
                appInput
                [border]="true"
                [noIcon]="true"
                [(ngModel)]="ourFilters.inboundFlightNumber"
                aria-labelledby="inbound_flightnum_input_label"
                id="flight-filters-input-flightnumber"
                i18n-placeholder
                placeholder="Enter flight number..."
                (ngModelChange)="applyFilter(ourFilters)"
                type="text"
              />
            </div>
          }
          <div class="deprange filters-group">
            <h3 id="departure_time_range">
              <b i18n="@@filterFlightsDepartureTime">Departure Time</b>
            </h3>
            <div class="custom-slider">
              <ngx-slider
                aria-labelledby="departure_time_range"
                [options]="inboundDepTimeOptions"
                (valueChange)="applyFilter(ourFilters)"
                id="flight-filter-dep-time2"
                (highValueChange)="applyFilter(ourFilters)"
                [(value)]="ourFilters.returnDepartureTime.min"
                [(highValue)]="ourFilters.returnDepartureTime.max"
              ></ngx-slider>
            </div>
          </div>
          <div class="arrrange filters-group">
            <h3 id="arrival_time_range">
              <b i18n="@@filterFlightsArrivalTime">Arrival Time</b>
            </h3>
            <div class="custom-slider">
              <ngx-slider
                aria-labelledby="arrival_time_range"
                [options]="inboundArrTimeOptions"
                (valueChange)="applyFilter(ourFilters)"
                id="flight-filter-arr-time2"
                (highValueChange)="applyFilter(ourFilters)"
                [(value)]="ourFilters.returnArrivalTime.min"
                [(highValue)]="ourFilters.returnArrivalTime.max"
              ></ngx-slider>
            </div>
          </div>
          <div class="depPorts filters-group">
            <fieldset>
              <legend>
                <h3>
                  <b i18n="@@filterFlightsDepartFrom">Depart from</b>
                </h3>
              </legend>
              <app-select-filter
                [items]="ourFilters?.depatureReturnAirport"
                [inbound]="true"
                (change)="applyFilter(ourFilters)"
              ></app-select-filter>
            </fieldset>
          </div>
          <div class="arrPorts filters-group">
            <fieldset>
              <legend>
                <h3>
                  <b i18n="@@filterFlightsArriveAt">Arrive at</b>
                </h3>
              </legend>
              <app-select-filter
                [items]="ourFilters?.arrivalReturnAirport"
                [inbound]="true"
                (change)="applyFilter(ourFilters)"
              ></app-select-filter>
            </fieldset>
          </div>
        </ng-template>
      </li>
    }
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
  <div class="flightFilterHeader">
    <ng-container>
      <div class="mainframe" id="filters">
        <div class="flex-column-container">
          <button
            appButton="small"
            (click)="clear()"
            i18n="@@fligthfilterClear"
            id="flight-filters-clear"
            aria-label="Clear filters"
          >
            Clear
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</app-filters-slider>
